import { useRecoilTask, type RecoilTaskInterface } from 'recoil-toolkit';

import { userService } from '../../../../api';
import { userState } from '../../../../state/user';
import { dashboardsPrjectPlanState } from './atom';

const saveDashboardSettings =
  ({ set, snapshot }: RecoilTaskInterface) =>
  async () => {
    const currentUser = snapshot.getLoadable(userState).getValue();
    const { layoutsSetting } = snapshot.getLoadable(dashboardsPrjectPlanState).getValue();
    const { dashboardProjectTaskSettings } = await userService.update({
      id: currentUser.id,
      data: {
        dashboardProjectTaskSettings: layoutsSetting,
      },
    });

    set(userState, (prevState) => ({
      ...prevState,
      dashboardProjectTaskSettings,
    }));
  };

export const useSaveDashboardSettings = () =>
  useRecoilTask(saveDashboardSettings, [], {
    dataSelector: dashboardsPrjectPlanState,
    errorStack: true,
  });
